import ApiClient from '../../../lib/ApiClient'

const authService = {
  async login(email, password) {
    try {
      const response = await ApiClient.post('/auth/generate', {
        email,
        password,
        deviceInfo: this.generateDeviceInfo(),
      })
      // El servidor establece las cookies httpOnly automáticamente (para
      // entornos same-site) Y devuelve el accessToken en el cuerpo (para
      // entornos cross-site donde las cookies de terceros están bloqueadas).
      return response.data
    } catch (error) {
      throw new Error(this.handleAuthError(error))
    }
  },

  async logout() {
    try {
      await ApiClient.post('/auth/logout', {}, { timeout: 5000 })
    } catch (error) {
      console.warn('Error no crítico durante logout:', error.message)
    }
  },

  /**
   * Restaura la sesión en recargas de página mediante un silent refresh.
   * Llama a POST /auth/refresh: el servidor lee la cookie httpOnly refresh_token
   * (si el navegador la envía en contexto cross-site) y devuelve un nuevo
   * accessToken en el cuerpo.
   * - 400/401 → sin cookie o token expirado → sesión cerrada (normal, no error)
   */
  async verifyToken() {
    try {
      const response = await ApiClient.post('/auth/refresh')
      const data = response.data
      if (!data?.accessToken) return { isValid: false }
      return { isValid: true, userData: data }
    } catch {
      return { isValid: false }
    }
  },

  async refreshToken() {
    try {
      const response = await ApiClient.post('/auth/refresh')
      return response.data
    } catch (error) {
      throw new Error(this.handleAuthError(error))
    }
  },

  generateDeviceInfo() {
    return `WebApp/${navigator.platform} (${navigator.userAgent})`
  },

  handleAuthError(error) {
    if (!error.response) {
      return error.message?.includes('Network Error')
        ? 'No hay conexión con el servidor'
        : 'Error de red. Verifica tu conexión.'
    }

    const status = error.response.status
    const errorData = error.response.data || {}
    const apiMessage = errorData.message || errorData.error || ''

    const isNotVerified =
      apiMessage.toLowerCase().includes('no verificada') ||
      apiMessage.toLowerCase().includes('account_not_verified')

    if (isNotVerified) {
      return 'Cuenta no verificada. Revisa tu email para activar tu cuenta.'
    }

    const errorMap = {
      400: apiMessage || 'Solicitud incorrecta',
      401: 'Credenciales inválidas',
      403: 'Acceso no autorizado',
      429: 'Demasiados intentos. Por favor espera.',
      500: 'Error interno del servidor',
    }

    const specificMessages = {
      invalid_credentials: 'Email o contraseña incorrectos',
      account_not_verified: 'Cuenta no verificada',
      token_expired: 'Sesión expirada',
      token_revoked: 'Sesión finalizada en otro dispositivo',
    }

    return (
      specificMessages[apiMessage] ||
      errorMap[status] ||
      `Error ${status}: ${apiMessage}`
    )
  },
}

export default authService
